import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { SyntheticEvent } from "react";

import { Switch } from "@/components/Form/Base/switch.component";
import { StorePickerModal } from "@/components/Store/StorePicker/storePickerModal.container";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { StorePickerModalStates } from "@/utils/enums";

import { useAvailableInStore } from "../../hooks/useAvailableInStore/useAvailableInStore.hook";

type AvailableInStoreProps = {
    className?: string;
};

export const AvailableInStore = ({ className }: AvailableInStoreProps) => {
    const { t } = useGranite();

    const {
        storePickerModalState,
        preferredStore,
        count,
        selected,
        onSelectStore,
        onRefine,
        onStorePickerModalClose,
        onStorePickerModalSubmit
    } = useAvailableInStore();

    const handleOnSelectStoreClick = (
        event: SyntheticEvent<HTMLButtonElement>
    ) => {
        event.preventDefault();
        onSelectStore();
    };

    return (
        <>
            <div
                className={cn(
                    "tw:flex tw:items-center tw:bg-grey-light tw:py-1.5 tw:px-3 tw:rounded-sm tw:gap-1",
                    "tw:lg:bg-transparent",
                    className
                )}
            >
                <span>
                    {!preferredStore &&
                        t(
                            "search.filters.availableInStore.availableIn.noStore"
                        )}
                    {preferredStore &&
                        selected &&
                        t("search.filters.availableInStore.availableIn.active")}
                    {preferredStore &&
                        !selected &&
                        t(
                            "search.filters.availableInStore.availableIn.inactive"
                        )}
                </span>
                {!!preferredStore && (
                    <>
                        <span className={cn("tw:font-bold")}>
                            {preferredStore.shopName}
                        </span>
                        ({count})
                    </>
                )}
                <Button
                    className={cn("tw:p-0")}
                    color={"link"}
                    onClick={handleOnSelectStoreClick}
                >
                    {preferredStore
                        ? t("search.filters.availableInStore.changeStore")
                        : t("search.filters.availableInStore.selectStore")}
                </Button>
                {!!preferredStore && (
                    <Switch
                        name={"filter"}
                        value={selected}
                        onToggle={onRefine}
                        disabled={!count}
                        className={cn("tw:inline-block")}
                    />
                )}
            </div>
            <StorePickerModal
                isOpen={storePickerModalState !== StorePickerModalStates.Closed}
                type={StorePickerType.SELECT}
                displayStockLevel={false}
                infoLink={null}
                storeCode={preferredStore?.code ?? null}
                fixedFeatures={[]}
                onClose={onStorePickerModalClose}
                onSubmit={onStorePickerModalSubmit}
            />
        </>
    );
};
